// Currency + preset amounts for the astrologer's price range (composed into a
// display string like "HK$ 1,000 - 3,000").
export const CURRENCY_OPTIONS = [
  { value: 'HK$', label: '港幣 HK$' },
  { value: 'NT$', label: '新台幣 NT$' },
  { value: 'RMB', label: '人民幣 RMB' },
  { value: 'MOP', label: '澳門幣 MOP' },
  { value: 'US$', label: '美元 US$' },
  { value: 'SGD', label: '新加坡幣 SGD' },
];

export const PRICE_AMOUNTS = [
  300, 500, 800, 1000, 1500, 2000, 2500, 3000,
  4000, 5000, 6000, 8000, 10000, 15000, 20000, 30000, 50000,
];
